import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="reative-page min-h-screen py-8 px-4" style={{ backgroundColor: '#0d0d0f' }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-4xl mx-auto pb-8">

        {/* Banner com Degradê */}
        <div className="rounded-3xl shadow-lg p-6 md:p-12 mb-8 border border-gray-700" style={{ backgroundColor: '#16161a' }}>
          <motion.h1
            initial={{ scale: 0.95 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5 }}
            className="font-serif font-bold text-center text-white mb-4"
            style={{ fontFamily: 'Georgia, serif', fontSize: 'clamp(24px, 6vw, 60px)' }}>
            Teste dos <span className="numerals">4</span> Elementos
          </motion.h1>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
            className="text-center text-amber-400 italic mb-6 md:mb-8">
            Descubra qual elemento está bloqueado<br className="md:hidden" /> em sua vida
          </motion.p>

          {/* Texto de Apresentação */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
            className="text-center max-w-2xl mx-auto mb-8 md:mb-10 px-4">
            <p className="text-gray-300 leading-relaxed mb-4">
              Descubra qual bloqueio invisível está fazendo você viver ciclos de escassez, 
              ansiedade e conflitos nas relações.
            </p>
          </motion.div>

          {/* Ícones dos Elementos */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.7 }}
            className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-8 md:mb-12 max-w-3xl mx-auto px-4">
            
            {/* Terra - Verde Musgo */}
            <div className="rounded-2xl p-4 md:p-6 shadow-md text-center border border-green-700" style={{ backgroundColor: '#0f1a12' }}>
              <div className="text-4xl md:text-5xl mb-2 md:mb-3">🌱</div>
              <h3 className="font-bold text-green-400" style={{ fontSize: 'clamp(16px, 4vw, 18px)' }}>Terra</h3>
              <p className="text-green-500" style={{ fontSize: 'clamp(14px, 3vw, 14px)' }}>Estabilidade</p>
            </div>

            {/* Água - Azul Profundo */}
            <div className="rounded-2xl p-4 md:p-6 shadow-md text-center border border-blue-700" style={{ backgroundColor: '#0a1220' }}>
              <div className="text-4xl md:text-5xl mb-2 md:mb-3">🌊</div>
              <h3 className="font-bold text-blue-400" style={{ fontSize: 'clamp(16px, 4vw, 18px)' }}>Água</h3>
              <p className="text-blue-500" style={{ fontSize: 'clamp(14px, 3vw, 14px)' }}>Emoção</p>
            </div>

            {/* Fogo - Laranja/Dourado */}
            <div className="rounded-2xl p-4 md:p-6 shadow-md text-center border border-orange-600" style={{ backgroundColor: '#1a0e00' }}>
              <div className="text-4xl md:text-5xl mb-2 md:mb-3">🔥</div>
              <h3 className="font-bold text-orange-400" style={{ fontSize: 'clamp(16px, 4vw, 18px)' }}>Fogo</h3>
              <p className="text-orange-500" style={{ fontSize: 'clamp(14px, 3vw, 14px)' }}>Ação</p>
            </div>

            {/* Ar - Lilás/Roxo */}
            <div className="rounded-2xl p-4 md:p-6 shadow-md text-center border border-purple-600" style={{ backgroundColor: '#120a1e' }}>
              <div className="text-4xl md:text-5xl mb-2 md:mb-3">🌪️</div>
              <h3 className="font-bold text-purple-400" style={{ fontSize: 'clamp(16px, 4vw, 18px)' }}>Ar</h3>
              <p className="text-purple-500" style={{ fontSize: 'clamp(14px, 3vw, 14px)' }}>Equilíbrio</p>
            </div>
          </motion.div>

          {/* Botão de Início */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.9 }}
            className="text-center px-4">
            <button
              onClick={() => navigate('/captura')}
              className="bg-gradient-to-r from-amber-600 to-amber-700 hover:from-amber-700 hover:to-amber-800 text-white font-bold rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 w-[90%] md:w-auto md:px-16"
              style={{ fontSize: 'clamp(16px, 4vw, 24px)', minHeight: '52px', paddingTop: '14px', paddingBottom: '14px' }}>
              Começar o Teste
            </button>
          </motion.div>
        </div>

        {/* Informações Adicionais */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.1 }}
          className="text-center space-y-4 mb-8 px-4">
          <div className="flex items-center justify-center gap-3 md:gap-4 text-gray-400 flex-wrap" style={{ fontSize: 'clamp(16px, 3.5vw, 16px)' }}>
            <span className="flex items-center gap-2">
              <span className="text-amber-600">✨</span>
              <span>Gratuito</span>
            </span>
            <span>•</span>
            <span>Resultado imediato</span>
            <span>•</span>
            <span><span className="numerals">12</span> perguntas rápidas</span>
          </div>
          
          <div className="mt-6">
            <p className="font-semibold text-amber-400" style={{ fontSize: 'clamp(18px, 4.5vw, 20px)' }}>Método desenvolvido por Mônica Maria
            </p>
            <p className="text-gray-400" style={{ fontSize: 'clamp(16px, 3.5vw, 16px)' }}>Especialista em Desbloqueio Emocional e Reequilíbrio Interno.</p>
          </div>
        </motion.div>

        {/* Rodapé */}
        <motion.div initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.3 }}
        className="text-center text-gray-600 border-t border-gray-800 pt-6 px-4" style={{ fontSize: 'clamp(14px, 3vw, 14px)' }}>
          <p className="mb-2">Material exclusivo e protegido.</p>
          <p className="font-semibold mb-2">Mônica Maria, Reacenda Luz.</p>
          <p>Proibida a reprodução sem autorização.</p>
        </motion.div>
      </motion.div>
    </div>);

}
